<template>
    <section>
        <p
            class="
                is-size-5
                has-text-centered has-text-weight-bold
                is-uppercase
                pb-4
                has-background-very-light-pink
            "
        >
            {{ $t('Sessions.question_detail_data') }}
        </p>

        <hr class="navbar-divider has-background-grey-lighter mt-0" />

        <table
            cellspacing="0"
            class="question-table mt-2 mb-4"
            style="width: 100%"
        >
            <thead>
                <tr style="border-bottom: 1px solid #dbdbdb">
                    <th
                        class="has-text-centered pb-2 pt-0"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.total_question_number') }}
                    </th>
                    <th
                        class="has-text-centered pb-2 pt-0"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.total_points') }}
                    </th>
                    <th
                        class="has-text-centered pb-2 pt-0"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.right_questions') }}
                    </th>
                    <th
                        class="has-text-centered pb-2 pt-0"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.failed_questions') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="has-text-centered">
                        {{ player.questions.length }}
                    </td>
                    <td class="has-text-centered">
                        {{ totalQuestionPoints }}
                    </td>
                    <td class="has-text-centered">
                        {{ answeredRight }}
                    </td>
                    <td class="has-text-centered">
                        {{ player.questions.length - answeredRight }}
                    </td>
                </tr>
            </tbody>
        </table>

        <hr class="navbar-divider has-background-grey-lighter mt-0" />

        <table
            cellspacing="0"
            class="question-detail-table mt-2 mb-4"
            style="width: 100%"
        >
            <thead>
                <tr style="border-bottom: 1px solid #dbdbdb">
                    <th
                        class="has-text-centered pb-2"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.question') }}
                    </th>
                    <th
                        class="has-text-centered pb-2"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.question_type') }}
                    </th>
                    <th
                        class="has-text-centered pb-2"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.time_spent') }}
                    </th>
                    <th
                        class="has-text-centered pb-2"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.user_answer') }}
                    </th>
                    <th
                        class="has-text-centered pb-2"
                        style="line-height: 2.5rem"
                    >
                        {{ $t('Sessions.points_obtained') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="question in player.questions"
                    :key="question._id"
                    class="is-bordered-bottom"
                >
                    <td class="is-fixed-width pb-2">
                        {{ question.title | strippedContent }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ $t('creation.answer_type.' + question.answerType) }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ questionResponseTime(question.scores) }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ questionUserAnswer(question) }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ questionObtainedPoints(question.scores) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
import _ from 'underscore';
import { timeFormat } from '@/lib/helpers';

export default {
    name: 'SessionDetailPlayerQuestionsPDF',
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    filters: {
        timeSpent(time) {
            return timeFormat(+time) + ' min';
        },
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
    },
    computed: {
        totalQuestionPoints() {
            let points = 0;
            for (let question of this.player.questions) {
                let userAnswer = _._.filter(question.scores, (score) => {
                    //console.log(score.profile, this.player._id);
                    if (score.profile) {
                        return (
                            score.points > 0 && score.profile == this.player._id
                        );
                    } else {
                        return (
                            score.points > 0 &&
                            score.owner._id == this.player._id
                        );
                    }
                });
                if (userAnswer.length) {
                    points = points + userAnswer[0].points;
                }
            }
            return points;
        },
        answeredRight() {
            let correctAnswers = 0;
            for (let question of this.player.questions) {
                if (
                    _.filter(question.scores, (score) => {
                        if (score.profile) {
                            return (
                                score.points > 0 &&
                                score.profile == this.player._id
                            );
                        } else {
                            return (
                                score.points > 0 &&
                                score.owner._id == this.player._id
                            );
                        }
                    }).length
                ) {
                    correctAnswers++;
                }
            }
            return correctAnswers;
        },
    },
    methods: {
        questionResponseTime(scores) {
            let scoreData = _.filter(scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });
            if (scoreData.length) {
                return this.$options.filters.timeSpent(scoreData[0].time);
            }
        },
        questionObtainedPoints(scores) {
            let scoreData = _.filter(scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });
            if (scoreData.length) {
                return scoreData[0].points;
            }
        },
        questionUserAnswer(question) {
            let scoreData = _.filter(question.scores, (score) => {
                if (score.profile) {
                    return score.profile == this.player._id;
                } else {
                    return score.owner._id == this.player._id;
                }
            });

            if (scoreData.length) {
                if (
                    question.answerType == 'SINGLE' ||
                    question.answerType == 'FREETEXT'
                ) {
                    if (typeof scoreData[0].answer.value != 'string') {
                        return scoreData[0].answer.value[0].value;
                    } else {
                        return scoreData[0].answer.value;
                    }
                } else if (question.answerType == 'HANGMAN') {
                    return scoreData[0].answer.value.join();
                } else if (question.answerType == 'MULTIPLE') {
                    let userAnswer = [];
                    for (let answer of scoreData[0].answer.value) {
                        userAnswer.push(answer.value);
                    }
                    return userAnswer.join();
                }
            }
        },
    },
};
</script>

<style scoped>
.table tr:not(.is-bordered-bottom) {
    border: none;
}
.content table td {
    border: none;
}

.content .table.is-vcentered td {
    vertical-align: middle;
}
</style>
